import debouncePromise from 'debounce-promise';
import { get, trim } from 'lodash';

import validation from '../../../scripts/services/validation';

import template from './address-input.jade';
import './typeahead-item.tpl.jade';
import './typeahead-popup.tpl.jade';

const validationSearchMessages = {
  required: 'Введите адрес вручную или передвиньте маркер на карте',
  needAddress: 'Укажите адрес',
  serverError: '<b>Ошибка на сервере!</b> Попробуйте ввести адрес повторно или подвинуть метку на карте',
};

export default angular
  .module('cian.addForm.addressInput', [])
  .directive('cianAfAddressAddressInput', () => ({
    scope: {},
    bindToController: {
      geo: '=',
      form: '=',
      isDisplayHint: '=',
    },
    controller: [
      'geoSelectorService', '$scope', 'geoService', '$q', 'deviceService',
      function (
        geoSelectorService, $scope, geoService, $q, deviceService,
      ) {
        $scope.isMobile = deviceService.isMobile;

        let suggestion;
        let delayedSuggestionQuery = false;

        $scope.address = trim(this.geo.address);

        $scope.geoObjectProcessed = false;
        $scope.isAddressValidated = false;

        $scope.validationSearch = validation(this.form, 'address', validationSearchMessages);

        $scope.isValidationRequired = () => {
          return this.form['address']
            ? $scope.validationSearch.invalid()
            : false;
        };

        $scope.isValidationWarning = () => $scope.address.$error.serverError;

        let ymaps;

        geoSelectorService.ready((_ymaps) => {
          ymaps = _ymaps;

          getSuggestions($scope.address, true);
        });

        /**
         * Получить элементы для саджеста, в отдельных категориях коммерции возвращаем комбинированый список - адреса и БЦ/ТЦ
         * Саджест в любом случае пишет адрес в ad.address, но при выборе БЦ мы иницииуруем доп. действия в методе selectAddress
         * @param queryText
         * @param firstLoad
         * @return {*|Promise.<TResult>}
         */
        // todo: kravets check delayedSuggestionQuery and firstload
        const getSuggestions = (queryText, firstLoad) => {
          if (!ymaps || !queryText) {
            return $q.when([]);
          }

          return ymaps.suggest(`Россия, ${queryText}`, getBoundaryBox())
            .then((addresses) => {
              $scope.handleSuggestionChange(addresses, firstLoad);

              $scope.$apply();

              return addresses;
            });
        };

        $scope.getSuggestionsDebounced = debouncePromise(getSuggestions, 200);

        /**
         * Преобразовывает строку с координатами квадрата window.addFormState.geo.bbox
         * в двумерный массив чисел этих координат и создает объект параметров для саджеста
         * @return Object { boundedBy: Number[][] }
         */
        const getBoundaryBox = () => {
          if (geoService.userGeo && geoService.userGeo.bbox) {
            const bboxStringsArr = String(geoService.userGeo.bbox).split(',');
            const bboxIntArr = bboxStringsArr.map(item => Number(item));
            const boundaryBox = {
              boundedBy: [
                [bboxIntArr[1], bboxIntArr[0]],
                [bboxIntArr[3], bboxIntArr[2]]
              ]
            };
            return boundaryBox;
          } else {
            return {};
          }
        };

        $scope.handleSuggestionChange = (items) => {
          if (items && items.length && suggestion !== items[0].displayName) {
            suggestion = items[0].displayName;
          }
        };

        $scope.handleUserInputChanged = (item) => {
          if (!ymaps) {
            return;
          }

          const value = item && item.value
            ? item.value
            : this.form['address'].$modelValue;

          ymaps.geocode(value, { json: true })
            .then((response) => {
              const pos = get(response, 'GeoObjectCollection.featureMember.0.GeoObject.Point.pos');

              if (!pos) {
                return;
              }

              // Разбиваем строку с координатами на элементы по пробелу и приводим значения к числу
              const [lng, lat] = pos.split(' ').map(Number);

              this.geo.coordinates = { lat, lng };
              this.isDisplayHint = true;

              $scope.$apply();
            })
            .catch(() => {
              this.form['address'].$setValidity('serverError', false);
            });
        };

        const detachGeoObjectProcessed = $scope.$watch(() => $scope.geoObjectProcessed, (value, oldValue) => {
          if (value !== oldValue) {
            $scope.geoObjectProcessed = value;
            this.form['address'].$setValidity('serverError', !value);
          }
        });

        const detachGetSuggestions = $scope.$watch(() => $scope.address, (value, oldValue) => {
          if (value !== oldValue) {
            delayedSuggestionQuery = value;
          }
        });

        $scope.$on('$destroy', () => {
          detachGeoObjectProcessed();
          detachGetSuggestions();
        });
      }
    ],
    controllerAs: 'addressInput',
    template,
  }))
  .name;
